var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"mobilePhoneInput\"> <input type=\"text\" class=\"form-control\" autocomplete=\"{{autocomplete}}\" name=\"{{name || 'phoneField'}}\" placeholder=\"{{phonePlaceholder}}\" ng-model=\"phone\" ui-mask=\"380 (99) 999 99 99\" ng-paste=\"phonePaste($event, phone)\" required=\"{{required}}\" tabindex=\"{{tabindex}}\" phoneinput> </div>";
ngModule.run(["$templateCache",function(c){c.put("mobilePhone/templates/mobilePhone.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/mobilePhone/templates/mobilePhone.html
 ** module id = 56
 ** module chunks = 1
 **/